import { Stack } from '@mui/material';
import { SearchWithBgIcon } from 'icons/search-with-bg';
import s from './no-results.module.scss';

const NoResults = () => {
  return (
    <div className={s.container}>
      <Stack gap={0.5} alignItems="center" justifyContent="center">
        <div className={s.heading}>
          <SearchWithBgIcon style={{ width: '30px', height: '30px' }} /> No results
        </div>
      </Stack>
    </div>
  );
};

export default NoResults;
